import React from "react";
import Homepage from "../../component/home/banner";
const Home = () => {
  return (
    <React.Fragment>
      <Homepage />
    </React.Fragment>
  );
};
export default Home;
